import React, { useState, useRef, useEffect } from "react";
import { Divider, Button, Form, Select, Tabs, Modal } from "antd";
import { ChartPreview } from "./ChartPreview";
import { SingleChartField } from "./SingleChartField";

export const SingleChartCustomizer = ({ chartManager }) => {
  const containerRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const [containerWidth, setContainerWidth] = useState(400); // Default fallback

  useEffect(() => {
    let throttleTimeout = null;

    const handleScroll = () => {
      if (throttleTimeout === null) {
        throttleTimeout = setTimeout(() => {
          if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            setIsSticky(rect.top <= 0);
          }
          throttleTimeout = null;
        }, 100);
      }
    };

    // 1) Invoke handleScroll immediately to detect if we're already scrolled down.
    handleScroll();

    // 2) Then add the scroll listener as usual.
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (throttleTimeout) clearTimeout(throttleTimeout);
    };
  }, []);
  const editState = chartManager.editingChart;

  if (editState === null) {
    return <div style={{ flex: 1, padding: "20px" }} />;
  }

  // 3) Use containerWidth in your style
  const containerStyle = {
    border: "1px solid #eee",
    padding: "20px",
    position: isSticky ? "fixed" : "relative",
    top: isSticky ? 80 : "auto",
    zIndex: isSticky ? 1000 : "auto",
    width: isSticky ? containerWidth : "auto",
  };

  const mutableKeys = editState.mutableParameters;

  return (
    <div ref={containerRef} style={{ flex: 1, padding: "0px", width: "100%" }}>
      <div
        key={"SCC_Outer" +
          editState.key +
          "_" +
          editState.index +
          "_" +
          editState?.chartType?.type
        }
        style={containerStyle}
      >
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Add Custom Chart" key="1">
            <Form
              name="player-form"
              layout="horizontal"
              labelAlign="left"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 10 }}
            >
              <Form.Item label="Chart Type" name="chart_type"style={{marginBottom:"2px"}}>
                <Select
                  value={editState.chartType["_type"]}
                  showSearch
                  optionFilterProp="value"
                  onChange={chartManager.switchEditChartType}
                  defaultValue={editState.chartType["_type"]}
                  style={{ width: "200px" }}
                >
                  {chartManager.chartTypeOptions.map((opt) => (
                    <Select.Option key={opt.key} value={opt.key}>
                      {opt.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Divider style={{marginTop:"10px",marginBottom:"14px"}}/>
              <div key={"chartVer" + editState.ver}>
                {mutableKeys.map((innerKey) => (
                  <SingleChartField
                    key={
                      "SCF" +
                      editState.key +
                      "_" +
                      editState.index +
                      "_" +
                      editState.chartType.type +
                      "_" +
                      innerKey
                    }
                    chartManager={chartManager}
                    keyId={innerKey}
                  />
                ))}
              </div>
            </Form>
            {editState?.currentValue?.type !== "placeholder" ? <div style={{height:"16px"}}/> : null}
            <div
              style={{
                width: "100%",
                display: "flex",
                gap: 16,
              }}
            >
              <div>
                <Button
                  type="primary"
                  style={{ width: "170px" }}
                  onClick={() => chartManager.handleSaveEditChart()}
                >
                  Save Custom Chart
                </Button>
              </div>
              {chartManager.getAllStateCharts('overview').length > 1 ? (
                <div>
                  <Button
                    danger
                    type="primary"
                    style={{ width: "170px" }}
                    onClick={() =>
                      Modal.confirm({
                        title: "Confirm Deletion",
                        content: "Are you sure you want to delete this custom chart?",
                        okText: "Yes",
                        cancelText: "No",
                        onOk: () => chartManager.handleRemoveChartFromOverview(editState.index),
                      })
                    }
                  >
                    Delete Custom Chart
                  </Button>
                </div>
              ) : null}
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Chart Preview" key="TC_2" disabled={editState?.currentValue?.type === "placeholder"}>
            <ChartPreview chartManager={chartManager} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};
